import {
  items,
  required,
  shape,
  fromModel,
  stopOnFirstFailure,
  Validator,
  Success,
  Failure,
  ValidationError
} from '@totalsoft/pure-validations';
import { uniqueProperty } from 'utils/simple-validations';
import i18next from 'i18next';
import { SelfPartnerTypeId } from './constants';

export const baseTypesValidator = Validator(function baseTypesValidator(value, context) {
  if (context.parentModel.id === SelfPartnerTypeId) return Success; // The partner type "Societate proprie", with partnerTypeId 0, doesn't have by default selected base types configured
  if (context.parentModel.baseTypes?.some(x => x.isSelected === true)) return Success;
  else return Failure(ValidationError(i18next.t('PartnerType.NoBaseTypeSelected')));
});

export const uniquePropertyOnPartnerType = property =>
  Validator(function propertiesValidator(value, context) {
    if (!property.editing) return Success;
    var existingProperties = context.parentContext.parentModel.filter(x => !x.editing);
    if (!existingProperties) return Success;
    return existingProperties.some(x => x.propertyId === property.propertyId)
      ? Failure(ValidationError(i18next.t('PartnerType.Details.PartnerTypeXProperty.UniquePropertyValidation')))
      : Success;
  });

export const partnerTypesValidator = items(
  shape({
    name: [required, uniqueProperty()] |> stopOnFirstFailure,
    code: [required, uniqueProperty()] |> stopOnFirstFailure,
    baseTypes: baseTypesValidator,
    properties: items(
      fromModel(model =>
        shape({
          propertyId: [required, uniquePropertyOnPartnerType(model)] |> stopOnFirstFailure
        })
      )
    )
  })
);
